import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

// tenant: global — an incomplete offer is a super-admin resource with no owning company yet, so it is
// deleted by its own id (/subscription-offers/:id) and not scoped to companies/:companyId. Deletion
// permanently invalidates the offer link.
export const useDeleteSubscriptionOffer = () => {
  const queryClient = useQueryClient();

  const {
    mutate: deleteSubscriptionOffer,
    mutateAsync: deleteSubscriptionOfferAsync,
    isPending,
  } = useIdempotentAppMutation([QueryKey.DELETE_SUBSCRIPTION_OFFER], {
    mutationFn: ({ id }: { id: string }, { headers }) =>
      ApiService.delete<{ id: string }, undefined>(
        {
          endpoint: BackendRoute.SUBSCRIPTION_OFFERS,
          routePath: [id],
        },
        { headers },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SUBSCRIPTION_OFFERS] });
    },
  });

  return { deleteSubscriptionOffer, deleteSubscriptionOfferAsync, isPending };
};
